var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal", {
    attrs: {
      variant: "drawer-no-scroll",
      "no-footer": "",
      "no-header": "",
      "aria-labelled-by": "languageSwitcherTitle",
    },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function (ref) {
            var activate = ref.activate
            return [
              _vm._t("default", null, null, {
                activate: activate,
                displayName: _vm.displayName,
              }),
            ]
          },
        },
        {
          key: "body",
          fn: function (ref) {
            var deactivate = ref.deactivate
            var updateFocusable = ref.updateFocusable
            var getFocusableElements = ref.getFocusableElements
            return [
              _c("language-switcher-list", {
                attrs: { languages: _vm.languages },
                on: {
                  close: deactivate,
                  "update-focusable": updateFocusable,
                  "get-focusable-elements": getFocusableElements,
                },
              }),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }